import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'

/** TRANSLATION*/
import { useTranslation } from 'react-i18next'


/** API */
import ProductSymptomsApi from 'api/setting/default-products/product-symptom.api'

/** UTILS || SLICE */
import { submitModal } from 'app/slice/modal.slice'
import { isCreate, isDelete, isUpdate, isView } from 'utils/verification.utils'

/** COMPONENT */
import { faSearch, faTimes } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import AddCircleIcon from '@mui/icons-material/AddCircle'
import { Box, Grid, InputAdornment, Typography } from '@mui/material'
import HeaderCard from 'component/CardCustom/HeaderCard'
import { notiError, notiSuccess } from 'component/notifications/notifications'
import TableCustom from 'component/Table/TableCustom'
import TableRowCommon from 'component/Table/TableRowCommon'
import MainButton from 'new-components/buttons/main-button'
import SwitchButton from 'new-components/buttons/switch-button'
import SelectInput from 'new-components/inputs/select-input'
import TextInput from 'new-components/inputs/text-input'
import AlertModal from 'new-components/modal/alert-modal'
import PageModal from 'new-components/modal/page-modal'
import SnackbarComponent from 'new-components/snackbar/snackbar-component'

const permissions = {
  isCreate: isCreate(),
  isDelete: isDelete(),
  isUpdate: isUpdate(),
  isView: isView()
}

const initStateErrorMessage = {
  PRODUCT_SYMPTOM_DETAIL: ``,
  IS_DUPLICATE_PRODUCT_SYMPTOM_DETAIL: ``,
  PRODUCT_SYMPTOM_DETAIL_STRING_BASE: ``,
  PRODUCT_SYMPTOM_DETAIL_STRING_EMPTY: ``,
  PRODUCT_SYMPTOM_DETAIL_MAXIMUM_LENGTH: ``,
  PRODUCT_SYMPTOM_DETAIL_ANY_REQUIRED: ``,

  PRODUCT_SYMPTOM_DETAIL_EN: ``,
  IS_DUPLICATE_PRODUCT_SYMPTOM_DETAIL_EN: ``,
  PRODUCT_SYMPTOM_DETAIL_EN_STRING_BASE: ``,
  PRODUCT_SYMPTOM_DETAIL_EN_STRING_EMPTY: ``,
  PRODUCT_SYMPTOM_DETAIL_EN_MAXIMUM_LENGTH: ``,
  PRODUCT_SYMPTOM_DETAIL_EN_ANY_REQUIRED: ``
}
export default function MedicineSymptoms() {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const [productSymptoms, setProductSymptoms] = useState([])
  const [productSymptomId, setProductSymptomId] = useState(Number)
  const [detail, setProductSymptomDetail] = useState('')
  const [detailEn, setProductSymptomDetailEn] = useState('')
  const [productSymptomStatus, setProductSymptomStatus] = useState('')
  const [textLength, setTextLength] = useState<number>(0)
  const [textLengthEn, setTextLengthEn] = useState<number>(0)
  const [errorName, setErrorName] = useState<any>()
  const [errorMaxLength, setErrorMaxLength] = useState<boolean>(false)

  const [errorMessage, setErrorMessage] = useState(initStateErrorMessage)

  /** PAGINATION  */
  const [page, setPage] = useState(1)
  const [pageLimit, setPageLimit] = useState(10)
  const [rowCount, setRowCount] = useState(0)
  const [sortBy, setSortBy] = useState('createAt')
  const [sortType, setSortType] = useState('ASC')
  const [search, setSearch] = useState('')
  const [status, setStatus] = useState('ALL')
  const [disabledSubmit, setDisabledSubmit] = useState(false)
  const [isOpenAlertModal, setIsOpenAlertModal] = useState(false)
  const [statusAlertModal, setStatusAlertModal] = useState('')
  const [id, setId] = useState<number>(0)
  const [name, setName] = useState('')
  const [nameEn, setNameEn] = useState('')
  const [isOpenSnack, setIsOpenSnack] = useState(false)
  const [typeSnack, setTypeSnack] = useState<any>("success")
  const [labelSnack, setLabelSnack] = useState('')

  const [isOpenPageModal, setIsOpenPageModal] = useState(false)

  const loadData = async () => {
    try {
      const resp = await ProductSymptomsApi.findAll({
        group: 'MEDICINE',
        page: page,
        pageLimit: pageLimit,
        search: search,
        sortBy: sortBy,
        sortType: sortType,
        status: status === 'ALL' ? '' : status
      })
      if (resp.status === 200) {
        setRowCount(resp.headers['x-total'])
        setProductSymptoms(resp.data)
      } else {
        setProductSymptoms([])
      }
    } catch (error) {
      notiError('เกิดข้อผิดพลาด')
    }
  }

  useEffect(() => {
    loadData()
  }, [page, pageLimit, sortBy, sortType])


  const submit = () => {
    if (!detail) return setErrorMessage({ ...errorMessage, ...{ PRODUCT_SYMPTOM_DETAIL: t('PRODUCT_SYMPTOM.MESSAGE.PRODUCT_SYMPTOM_DETAIL') } })

    dispatch(submitModal())
    setDisabledSubmit(true)
    ProductSymptomsApi.create({ detail, detailEn, group: 'MEDICINE' })
      .then((res: any) => {
        if (res.status !== undefined && res.status === 201) {
          notiSuccess(t('PRODUCT_SYMPTOM.MESSAGE.SUCCESS.CREATE'), '', null, null)
          resetForm()
          loadData()
          setIsOpenPageModal(false)
        } else {
          const err = res.response.data
          setErrorMessage({ ...errorMessage, ...{ [err.message]: t(`PRODUCT_SYMPTOM.MESSAGE.${err.message}`) } })
        }
      })
      .catch((e) => {
        const err = e.response.data
        setErrorMessage({ ...errorMessage, ...{ [err.message]: t(`PRODUCT_SYMPTOM.MESSAGE.${err.message}`) } })
      }).finally(() => setDisabledSubmit(false))
  }

  const submitEdit = () => {
    if (!detail) return setErrorMessage({ ...errorMessage, ...{ PRODUCT_SYMPTOM_DETAIL: t(`PRODUCT_SYMPTOM.MESSAGE.PRODUCT_SYMPTOM_DETAIL`) } })

    dispatch(submitModal())
    setDisabledSubmit(true)
    ProductSymptomsApi.update(productSymptomId, { detail, detailEn, status: productSymptomStatus, group: 'MEDICINE' })
      .then((res: any) => {
        if (res.status !== undefined && res.status === 200) {
          notiSuccess(t(`PRODUCT_SYMPTOM.MESSAGE.SUCCESS.UPDATE`), '', null, null)
          resetForm()
          loadData()
          setIsOpenPageModal(false)
        } else {
          const err = res.response.data
          setErrorMessage({ ...errorMessage, ...{ [err.message]: t(`PRODUCT_SYMPTOM.MESSAGE.${err.message}`) } })
        }
      })
      .catch((e) => {
        const err = e.response.data
        setErrorMessage({ ...errorMessage, ...{ [err.message]: t(`PRODUCT_SYMPTOM.MESSAGE.${err.message}`) } })
      }).finally(() => setDisabledSubmit(false))
  }

  const clearErrorMessage = () => {
    setErrorMessage(initStateErrorMessage)
  }


  const handleChangeName = (e: any) => {
    setErrorName('')
    const name = e === '' ? '' : String(e)
    const contentLength = name.length

    if (contentLength > 40) {
      setErrorMaxLength(true)
    } else {
      setProductSymptomDetail(name)
      setTextLength(contentLength)
      setErrorMaxLength(false)
    }

  }
  const handleChangeNameEn = (e: any) => {
    const nameEn = e === '' ? '' : String(e)
    const contentLength = nameEn.length
    if (contentLength > 40) {
      setErrorMaxLength(true)
    } else {
      setProductSymptomDetailEn(nameEn)
      setTextLengthEn(contentLength)
      setErrorMaxLength(false)
    }
  }

  const resetForm = () => {
    setProductSymptomId(0)
    setProductSymptomDetail('')
    setProductSymptomDetailEn('')
    setProductSymptomStatus('')
    clearErrorMessage()
    setIsOpenPageModal(false)
    setTextLength(0)
    setErrorMaxLength(false)
    setTextLengthEn(0)
  }

  const onActive = () => {
    if (id) {
      ProductSymptomsApi.updateStatus(id, statusAlertModal).then((resp) => {
        if (resp.status === 200) {
          setIsOpenAlertModal(false)
          setIsOpenSnack(true)
          setTypeSnack("success")
          setLabelSnack(t('PRODUCT_SYMPTOM.MESSAGE.SUCCESS.UPDATE_STATUS'))
          loadData()
        } else {
          setIsOpenAlertModal(false)
          setIsOpenSnack(true)
          setTypeSnack("error")
          setLabelSnack(t('PRODUCT_SYMPTOM.MESSAGE.ERROR'))
        }
      })
    }
  }
  const onDelete = () => {
    if (id) {
      ProductSymptomsApi.remove(id).then((resp) => {
        if (resp.status === 200) {
          setIsOpenAlertModal(false)
          setIsOpenSnack(true)
          setTypeSnack("success")
          setLabelSnack(t('PRODUCT_SYMPTOM.MESSAGE.SUCCESS.DELETE'))
          loadData()
        } else {
          setIsOpenAlertModal(false)
          setIsOpenSnack(true)
          setTypeSnack("error")
          setLabelSnack(t('PRODUCT_SYMPTOM.MESSAGE.ERROR'))
        }
      })
    }
  }

  const onEdit = (data: any) => {
    const { productSymptomId: pdUseId, detail: pdUseDetail, status: pdUseStatus } = data
    setProductSymptomId(pdUseId)
    setProductSymptomDetail(pdUseDetail)
    setProductSymptomDetailEn(data?.detailEn)
    setProductSymptomStatus(pdUseStatus)
    setIsOpenPageModal(true)
    handleChangeNameEn(data?.detailEn)
    handleChangeName(pdUseDetail)
  }

  const onRequestSort = (sortByVal: string, sortTypeVal: string) => {
    setSortType(sortTypeVal)
    setSortBy(sortByVal)
  }

  const handleChangePage = (val: number) => {
    setPage(val)
  }

  const handleChangeRowsPerPage = (limit: number) => {
    setPageLimit(limit)
  }
  const handleChangeStatus = (statusVal: string) => {
    setStatus(statusVal)
  }
  const headCells = [
    { id: 'no', disablePadding: false, label: '#' },
    { id: 'detail', disablePadding: false, label: t('PRODUCT_SYMPTOM.TABLE.CELL.PRODUCT_SYMPTOM_DETAIL') },
    { id: 'detailEn', disablePadding: false, label: t('PRODUCT_SYMPTOM.TABLE.CELL.PRODUCT_SYMPTOM_DETAIL_EN') },
    { id: 'status', disablePadding: false, label: t('PRODUCT_SYMPTOM.TABLE.CELL.STATUS') },
    { id: 'updatedBy', disablePadding: false, label: t('PRODUCT_SYMPTOM.TABLE.CELL.UPDATED_BY') },
    { id: 'action', disablePadding: false, label: 'Action' }
  ]

  const renderData = (objData: any, no: number) => {
    no = page * pageLimit - pageLimit + no + 1
    const { productSymptomId: pdUseId, detail: pdUseDetail, detailEn: pdUseDetailEn, updatedBy, updatedAt, status: pdUseStatus } = objData
    const statusBtnActive = pdUseStatus === 'ACTIVE' ? true : permissions.isUpdate.disabled
    const statusBtnInActive = pdUseStatus === 'INACTIVE' ? true : permissions.isUpdate.disabled
    const objRenderData = {
      key: pdUseId,
      id: pdUseId,
      obj: objData,
      columns: [
        { option: 'TEXT', align: 'center', label: no },
        { option: 'TEXT', align: 'left', label: pdUseDetail },
        { option: 'TEXT', align: 'left', label: pdUseDetailEn },
        { option: 'STATUS', align: 'center', label: pdUseStatus },
        { option: 'UPDATE_BY', align: 'center', label: { updatedBy: updatedBy, updatedAt: updatedAt } },
        {
          option: 'ACTION',
          align: 'center',
          label: 'action',
          values: [
            { option: 'STATUS_ACTIVE', label: t(`STATUS.ACTIVE`), disabled: statusBtnActive },
            { option: 'STATUS_INACTIVE', label: t(`STATUS.INACTIVE`), disabled: statusBtnInActive },
            { option: 'DIVIDER', label: '', disabled: false },
            { option: 'EDIT', label: t(`BUTTON.EDIT`), disabled: permissions.isUpdate.disabled },
            { option: 'DELETE', label: t(`BUTTON.DELETE`), disabled: permissions.isDelete.disabled }
          ]
        }
      ]
    }
    return (
      <TableRowCommon
        {...objRenderData}
        onactive={() => handleSubmitModal(Number(objRenderData.id), 'ACTIVE', objRenderData.obj)}
        oninactive={() => handleSubmitModal(Number(objRenderData.id), 'INACTIVE', objRenderData.obj)}
        onedit={() => onEdit(objRenderData.obj)}
        ondelete={() => handleSubmitModal(Number(objRenderData.id), 'DELETE', objRenderData.obj)}
      />
    )
  }

  const handleSubmitModal = (id: number, status: string, obj?: any) => {
    setStatusAlertModal(status)
    setId(id)
    setIsOpenAlertModal(true)
    setName(obj.detail)
    setNameEn(obj.detailEn)
  }

  return (
    <Box>
      <AlertModal
        isOpen={isOpenAlertModal}
        title={t(`PRODUCT_SYMPTOM.ALERT.${statusAlertModal === 'DELETE' ? 'TITLE_DELETE' : 'TITLE_ACTIVE'}`)}
        message={t(`PRODUCT_SYMPTOM.ALERT.${statusAlertModal === 'DELETE' ? 'CONFIRM_DELETE_' : 'CONFIRM_STATUS'}`, { detail: name, detailEn: nameEn && `(${nameEn})`, status: t(`PRODUCT_SYMPTOM.ALERT.${statusAlertModal}`) })}
        type={statusAlertModal === 'DELETE' ? 'error' : 'warning'}
        handleClose={() => setIsOpenAlertModal(false)}
        onCancel={{ onClick: () => setIsOpenAlertModal(false), title: t('BUTTON.CANCEL') }}
        onSubmit={{ onClick: statusAlertModal === 'DELETE' ? onDelete : onActive, title: t('BUTTON.SUBMIT') }}
      />
      <SnackbarComponent
        onOpen={isOpenSnack}
        onClose={() => setIsOpenSnack(false)}
        label={labelSnack}
        type={typeSnack}
        transform={`translateX(calc(100vw - 100% - 32px)) translateY(calc(-100vh + 100% + ${window.innerHeight - 50}px))`}
        autoHideTime={3000}
      />
      <HeaderCard text={t('PRODUCT_SYMPTOM.TITLE')} />
      <Box paddingX="24px" paddingTop="16px">
        <Grid container spacing="16px">
          <Grid item xs={12} sm={6} md={3} xl={2}>
            <TextInput
              label={t('PRODUCT_SYMPTOM.SEARCH')}
              value={search}
              onChange={(event) => {
                setSearch(event.target.value)
              }}
              fullWidth
              inputProps={{
                endAdornment: (
                  <InputAdornment position="end" >
                    {!search ? <FontAwesomeIcon icon={faSearch} style={{ color: 'rgba(0, 0, 0, 0.6)', fontSize: 15 }} /> :
                      <FontAwesomeIcon
                        icon={faTimes}
                        onClick={() => {
                          setSearch('');
                        }}
                        style={{ color: 'rgba(0, 0, 0, 0.6)', fontSize: 17, cursor: 'pointer' }} />}
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3} xl={2}>
            <SelectInput
              onChange={(event) => {
                const value = event.target.value
                if (value) {
                  handleChangeStatus(value)
                }
              }}
              options={[
                { value: 'ALL', name: t('STATUS.ALL') },
                { value: 'ACTIVE', name: t('STATUS.ACTIVE') },
                { value: 'INACTIVE', name: t('STATUS.INACTIVE') }
              ]}
              label={t('STATUS.LABEL')}
              value={status}
              width="100%"
            />
          </Grid>
          <Grid item xs={12} sm={12} md={6} xl={8}>
            <Box display={'flex'} justifyContent={'space-between'}>
              <MainButton
                title={t('INPUT.SEARCH')}
                type='primary'
                variant='contained'
                style={{ width: '120px' }}
                onClick={() => {
                  setPage(1)
                  loadData()
                }} />

              <MainButton
                title={t('PRODUCT_SYMPTOM.BUTTON.ADD')}
                disabled={permissions.isCreate.disabled}
                type='primary'
                variant='contained'
                onClick={() => setIsOpenPageModal(true)}
                startIcon={<AddCircleIcon />}
              />
            </Box>
          </Grid>
        </Grid>
        <Box paddingTop="24px">
          <TableCustom
            page={page}
            pageLimit={pageLimit}
            sortType={sortType}
            sortBy={sortBy}
            onSort={onRequestSort}
            setPageLimit={handleChangeRowsPerPage}
            setPage={handleChangePage}
            rowCount={rowCount}
            headCells={headCells}
            rowsData={productSymptoms.map((val, i) => {
              return renderData(val, i)
            })}
          />
        </Box>
        <PageModal
          isOpen={isOpenPageModal}
          title={productSymptomId ? t('PRODUCT_SYMPTOM.TITLE_UPDATE') : t('PRODUCT_SYMPTOM.TITLE_CREATE')}
          size='XS'
          handleClose={resetForm}
          onCancel={{ onClick: resetForm, title: t('PRODUCT_SYMPTOM.BUTTON.CANCEL') }}
          onSubmit={{ onClick: productSymptomId ? submitEdit : submit, title: t('PRODUCT_SYMPTOM.BUTTON.SAVE'), disabled: disabledSubmit }}
        >
          <Box display="flex" flexDirection="column" gap="24px">
            {productSymptomId ? <Box display="flex" justifyContent="space-between" alignItems="center">
              <Typography>{t('INPUT.LABEL_STATUS')}</Typography>
              <SwitchButton onChange={() => setProductSymptomStatus(productSymptomStatus === 'ACTIVE' ? 'INACTIVE' : 'ACTIVE')} checked={productSymptomStatus === 'ACTIVE' ? true : false} />
            </Box> : ''}
            <TextInput
              onChange={(event) => {
                handleChangeName(event.target.value)
                clearErrorMessage()
              }}
              value={detail}
              label={t('PRODUCT_SYMPTOM.INPUT.PRODUCT_SYMPTOM_DETAIL')}
              helperText={
                errorMessage.PRODUCT_SYMPTOM_DETAIL ||
                errorMessage.IS_DUPLICATE_PRODUCT_SYMPTOM_DETAIL ||
                errorMessage.PRODUCT_SYMPTOM_DETAIL_STRING_BASE ||
                errorMessage.PRODUCT_SYMPTOM_DETAIL_STRING_EMPTY ||
                errorMessage.PRODUCT_SYMPTOM_DETAIL_MAXIMUM_LENGTH ||
                errorMessage.PRODUCT_SYMPTOM_DETAIL_ANY_REQUIRED
              }
              required
            />
            <TextInput
              onChange={(event) => {
                handleChangeNameEn(event.target.value)
                clearErrorMessage()
              }}
              value={detailEn}
              label={t('PRODUCT_SYMPTOM.INPUT.PRODUCT_SYMPTOM_DETAIL_EN')}
              helperText={
                errorMessage.PRODUCT_SYMPTOM_DETAIL_EN ||
                errorMessage.IS_DUPLICATE_PRODUCT_SYMPTOM_DETAIL_EN ||
                errorMessage.PRODUCT_SYMPTOM_DETAIL_EN_STRING_BASE ||
                errorMessage.PRODUCT_SYMPTOM_DETAIL_EN_STRING_EMPTY ||
                errorMessage.PRODUCT_SYMPTOM_DETAIL_EN_MAXIMUM_LENGTH ||
                errorMessage.PRODUCT_SYMPTOM_DETAIL_EN_ANY_REQUIRED
              }
              inputProps={{ value: detailEn }}
            />
          </Box>
        </PageModal>
      </Box>
    </Box>
  )
}
